import { getProxyUrl } from '@proxies/index'

export default async function fetchAcabadoZonaModeloAcabadoInfo(id: number) {
  const _info = await fetch(getProxyUrl(`api/acabados/getacabadozonamodeloacabadoinfo/${id}`), {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  })
  return _info.json()
}
